
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import LearnMore from "@/components/common/LearnMore.vue";
import Faq from "@/components/common/FAQ.vue";
import store from "@/store";
import { IBreadCrumbRoute } from "@/types/index";
import SharedRideServContent from "@/components/transService/SharedRideServContent.vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import ContactusContent from "@/components/contact/ContactusContent.vue";

export default Vue.extend({
  name: "Shared-Ride-Services",
  components: {
    Faq,
    HeroBanner,
    BreadCrumb,
    LearnMore,
    SharedRideServContent,
    ContactusContent,
  },
  mixins: [UIFeatureMixin],
  data() {
    return {
      routes: [
        { to: { name: "home" }, text: "Home" },
        {
          to: { name: "transServicesOverview" },
          text: "Transportation Services",
        },
        { to: { name: "sharedRideServices" }, text: "Shared Ride Services" },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "SRS_HERO_C,SRS_CONTEN,SRS_LEARN,SRS_HEADER,SHARD_RIDE,PG_SRS,PG_SRW,HME_THIS,NCOUNTY_1,NCOUNTY_2,NCOUNTY_3,AVAIL_CNTY,AVL_COUNTY,QUICK_SRCH,ER_INLINE,CHGLGN_TXT,ADMN_USR,MAIN,MAIN_TITLE,FMR,ENVRONMNT,ADA,FTP,MATP,PWD,SSR,CNTCT_US,CNT_US_C,SRS_CONTCT,SEL_CNTY,FLT_CNTIES,SRS_TRAING"
    );
  },
  computed: {
    isDataLoading: {
      get(): boolean {
        return store.getters.uiFeatureModule.getLoadingStatus;
      },
    },
  },
});
